import React from "react";
import { motion } from "framer-motion";
import { IMAGES } from "../lib/content";
import { Feather, Quote } from "lucide-react";

const AboutAuthor = () => {
  return (
    <section
      id="author"
      data-testid="author-section"
      className="relative py-28 md:py-40 bg-enchanted overflow-hidden"
    >
      <img
        src={IMAGES.fairyDoor}
        alt=""
        aria-hidden
        className="hidden lg:block absolute -left-20 bottom-0 w-80 opacity-30 pointer-events-none drift-anim"
      />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[4/5] max-w-md mx-auto rounded-[2rem] overflow-hidden glass-card !p-0">
            <img
              src={IMAGES.author}
              alt="Sybelle Cheesman"
              className="w-full h-full object-cover"
              data-testid="author-portrait"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#08140B]/60 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5">
              <span className="font-accent text-amber-300 text-lg">
                Storyteller in the Glade
              </span>
            </div>
          </div>
          <div className="absolute -top-6 -right-6 w-20 h-20 rounded-full bg-amber-400/15 border border-amber-400/40 backdrop-blur-md hidden md:flex items-center justify-center float-anim-slow">
            <Feather size={26} className="text-amber-300" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="lg:col-span-7"
        >
          <span className="font-accent text-xl text-amber-300">About the Author</span>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-white mt-3 leading-tight">
            Sybelle <span className="italic text-gradient-gold">Cheesman</span>
          </h2>
          <div className="section-divider mt-6 !mx-0" />

          <p className="mt-7 text-emerald-50/85 leading-relaxed text-lg">
            Sybelle Cheesman grew up tracing constellations with her
            grandmother and inventing kingdoms in the hollow of an old oak. She
            spent two decades teaching young readers before slipping into the
            woods of her imagination to discover Miara Mountain — and the tiny
            prince waiting at the door.
          </p>
          <p className="mt-4 text-emerald-50/75 leading-relaxed text-lg">
            Her stories are written for children who still believe in fairy
            doors, and for grown-ups who would like to believe again.
          </p>

          <blockquote className="mt-10 relative glass-card p-6 md:p-8" data-testid="author-quote">
            <Quote size={32} className="absolute -top-5 -left-3 text-amber-400/70 bg-[#08140B] rounded-full p-1.5" />
            <p className="font-heading italic text-xl md:text-2xl text-white leading-snug">
              “Every child carries a hidden door inside them. My stories are
              little keys, shaped like pixies.”
            </p>
            <div className="mt-4 text-amber-300/90 font-accent">— Sybelle</div>
          </blockquote>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutAuthor;
